<template>
  <div class="divBox">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="container">
          <el-form size="small" inline label-width="100px">
            <el-form-item label="维权类型：">
              <el-radio-group v-model="tableFrom.protection_type" type="button" @change="getList(1)">
                <el-radio-button label="">全部 {{ '(' +orderChartType.all?orderChartType.all:0 + ')' }}</el-radio-button>
                <el-radio-button
                  label="1"
                >订单维权 {{ '(' +orderChartType.protectionTypeOneself?orderChartType.protectionTypeOneself:0+ ')' }}</el-radio-button>
                <el-radio-button
                  label="2"
                >帮我维权 {{ '(' +orderChartType.protectionTypeExternal?orderChartType.protectionTypeExternal:0+ ')' }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="支付状态：">
              <el-radio-group v-model="tableFrom.is_pay" type="button" @change="getList(1)">
                <el-radio-button label="">全部</el-radio-button>
                <el-radio-button
                  label="1"
                >已支付 {{ '(' +orderChartType.payYes?orderChartType.payYes:0+ ')' }}</el-radio-button>
                <el-radio-button
                  label="0"
                >未支付 {{ '(' +orderChartType.payNo?orderChartType.payNo:0+ ')' }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="维权状态：">
              <el-radio-group v-model="tableFrom.protection_status" type="button" @change="getList(1)">
                <el-radio-button label="">全部</el-radio-button>
                <el-radio-button
                  label="0"
                >已提交 {{ '(' +orderChartType.protectionStatusSub?orderChartType.protectionStatusSub:0+ ')' }}</el-radio-button>
                <el-radio-button
                  label="2"
                >审核通过 {{ '(' +orderChartType.protectionStatusExamine?orderChartType.protectionStatusExamine:0+ ')' }}</el-radio-button>
                <el-radio-button
                  label="-1"
                >审核失败 {{ '(' +orderChartType.protectionStatusError?orderChartType.protectionStatusError:0+ ')' }}</el-radio-button>
                <el-radio-button
                  label="3"
                >维权完成 {{ '(' +orderChartType.protectionStatusFinish?orderChartType.protectionStatusFinish:0+ ')' }}</el-radio-button>
                <el-radio-button
                  label="-2"
                >取消维权 {{ '(' +orderChartType.protectionStatusCancel?orderChartType.protectionStatusCancel:0+ ')' }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="支付类型：">
              <el-radio-group v-model="tableFrom.pay_type" type="button" @change="getList(1)">
                <el-radio-button label="">全部</el-radio-button>
                <el-radio-button
                  label="balance"
                >余额支付 {{ '(' +orderChartType.payTypeB?orderChartType.payTypeB:0+ ')' }}</el-radio-button>
                <el-radio-button
                  label="weixin"
                >微信支付 {{ '(' +orderChartType.payTypeW?orderChartType.payTypeW:0+ ')' }}</el-radio-button>
                <el-radio-button
                  label="alipay"
                >支付宝支付 {{ '(' +orderChartType.payTypeA?orderChartType.payTypeA:0+ ')' }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="时间选择：" class="width100">
              <el-radio-group
                v-model="tableFrom.date"
                type="button"
                class="mr20"
                size="small"
                @change="selectChange(tableFrom.date)"
              >
                <el-radio-button
                  v-for="(item,i) in fromList.fromTxt"
                  :key="i"
                  :label="item.val"
                >{{ item.text }}</el-radio-button>
              </el-radio-group>
              <el-date-picker
                v-model="timeVal"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                size="small"
                type="daterange"
                placement="bottom-end"
                placeholder="自定义时间"
                style="width: 250px;"
                @change="onchangeTime"
              />
            </el-form-item>
            <el-form-item label="关键字：" class="width100" style="display: inline-block;">
              <el-input
                v-model="tableFrom.keywords"
                @keyup.enter.native="getList(1)"
                placeholder="请输入订单号/购买平台/购买商品/产品信息/用户信息"
                class="selWidth"
                size="small"
              >
                <el-button slot="append" icon="el-icon-search" size="small" class="el-button-solt" @click="getList(1)" />
              </el-input>
            </el-form-item>
            <el-form-item label="用户信息：" class="width100" style="display: inline-block;">
              <el-input
                v-model="tableFrom.username"
                @keyup.enter.native="getList(1)"
                placeholder="请输入用户昵称/手机号"
                class="selWidth"
                size="small"
              >
                <el-button slot="append" icon="el-icon-search" size="small" class="el-button-solt" @click="getList(1)" />
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <el-table
        v-loading="listLoading"
        :data="tableData.data"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          label="ID"
          prop="protection_id"
          min-width="50" />
        <el-table-column
          label="订单号"
          prop="protection_sn"
          min-width="150" />
        <el-table-column
          label="外部订单号"
          prop="outreachOrder.order_sn"
          min-width="150" />
        <el-table-column
          label="用户昵称"
          prop="user.nickname"
          min-width="100" />
        <el-table-column
          label="姓名"
          prop="user_name"
          min-width="100" />
        <el-table-column
          label="电话"
          prop="user_phone"
          min-width="100" />
        <el-table-column
          label="地址"
          prop="user_address"
          min-width="100" />
        <el-table-column
          label="购买平台"
          prop="shop_platform"
          min-width="100" />
        <el-table-column
          label="购买店铺"
          prop="shop_merchant"
          min-width="100" />
        <el-table-column
          label="购买日期"
          prop="shop_date"
          min-width="100" />
        <el-table-column
          label="购买产品"
          prop="shop_title"
          min-width="150" />
        <el-table-column
          label="维权类型"
          prop="protection_type_text"
          min-width="100" />
        <el-table-column
          label="维权状态"
          prop="protection_status_text"
          min-width="100" />
        <el-table-column
          label="支付状态"
          prop="is_pay_text"
          min-width="100" />
        <el-table-column
          label="支付金额"
          min-width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.pay_price ? scope.row.pay_price : 0  }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="支付类型"
          prop="pay_type_text"
          min-width="100" />
        <el-table-column
          label="维权结果"
          prop="protection_results_text"
          min-width="100" />
        <el-table-column
          label="创建时间"
          prop="create_time"
          min-width="160" />
        <el-table-column label="操作" min-width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="onDetail(scope.row.protection_id)">详情</el-button>
            <router-link  :to="{path: roterPre + '/protection/status/' + scope.row.protection_id}">
              <el-button type="text" size="small" class="mr10">状态</el-button>
            </router-link>
            <el-button type="text" size="small" @click="handleDelete(scope.row.protection_id, scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          :page-sizes="[20, 40, 60, 80]"
          :page-size="tableFrom.limit"
          :current-page="tableFrom.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
          @size-change="handleSizeChange"
          @current-change="pageChange"
        />
      </div>
    </el-card>
    <el-dialog v-if="dialogVisible" title='详情' :visible.sync="dialogVisible" width="700px">
      <div v-loading="loading" class="divBox">
        <el-card class="box-card">
          <el-form ref="formData"   label-width="120px" class="demo-ruleForm">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="订单ID：">
                  <div>{{formData.protection_id}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="订单号：">
                  <div>{{formData.protection_sn}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="姓名：">
                  <div>{{formData.user_name}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电话：">
                  <div>{{formData.user_phone}}</div>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="地址：">
                  <div>{{formData.user_address}}</div>
                </el-form-item>
              </el-col>
              <el-form-item label="身份证正面照：">
                  <div >
                    <el-image
                      style="width: 60px; height: 60px"
                      :src="formData.card_img"
                      :preview-src-list="[formData.card_img]"
                    />
                  </div>
              </el-form-item>
              <el-form-item label="身份证反面照片：">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 60px; height: 60px"
                    :src="formData.back_card_img"
                    :preview-src-list="[formData.back_card_img]"
                  />
                </div>
              </el-form-item>
              <el-col :span="12">
                <el-form-item label="购买平台：">
                  <div>{{formData.shop_platform}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="购买店铺：">
                  <div>{{formData.shop_merchant}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="购买日期：">
                  <div>{{formData.shop_date}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="购买商品：">
                  <div>{{formData.shop_title}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="详情说明：">
                  <div>{{formData.shop_desc}}</div>
                </el-form-item>
              </el-col>
              <el-form-item label='产品图片：'>
                <div v-for="(item, index) in formData.product_imgs" :key="index" style="display: inline-block; margin: 0 10px 10px 0">
                  <el-image
                    style="width: 80px; height: 80px"
                    :src="item || ''"
                    :preview-src-list="[item?item:'']"
                  />
                </div>
              </el-form-item>
              <el-col :span="12" v-if = 'formData.protection_type === 1'>
                <el-form-item label="外部订单id：">
                  <div>{{formData.outreach_order_id}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if = 'formData.protection_type === 1'>
                <el-form-item label="外部订单号：">
                  <div>{{formData.outreach_order.order_sn}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if = 'formData.protection_type === 1'>
                <el-form-item label="商品图片：">
                  <div class="demo-image__preview">
                    <el-image
                      style="width: 60px; height: 60px"
                      :src="formData.outreach_order.imageUrl"
                      :preview-src-list="[formData.outreach_order.imageUrl]"
                    />
                  </div>
                </el-form-item>
              </el-col>
              <el-col v-if = 'formData.protection_type === 1'>
                <el-form-item label="订单商品名称：" >
                  <div>{{formData.outreach_order.skuName}}</div>
                </el-form-item>
              </el-col>


              <el-col :span="12">
                <el-form-item label="用户：" v-if = 'formData.user'>
                  <span>{{formData.user.nickname}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="用户ID：" v-if = 'formData.user'>
                  <span>{{formData.user.uid}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="维权类型：">
                  <span>{{formData.protection_type_text}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="维权状态：">
                  <span>{{formData.protection_status_text}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="支付状态：">
                  <span>{{formData.is_pay_text}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="支付类型：">
                  <span>{{formData.pay_type_text}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="支付金额：">
                  <span>{{formData.pay_price}}</span>
                </el-form-item>
              </el-col>
              <el-form-item v-if="(formData.protection_type === 1 && formData.protection_status === 1 && formData.is_pay === 1) || (formData.protection_type === 2 && formData.protection_status === 0)" label="审核状态：" prop="protection_status">
                <el-radio-group v-model="ruleForm.protection_status">
                  <el-radio :label="2">通过</el-radio>
                  <el-radio :label="-1">拒绝</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="(formData.protection_type === 2 && formData.protection_status === 0 && ruleForm.protection_status===2)" label="维权支付金额" prop="error_msg">
                <el-input v-model="ruleForm.pay_price"  placeholder="请输入维权支付金额" />
              </el-form-item>
              <el-form-item v-if="((formData.protection_type === 1 && formData.protection_status === 1 && formData.is_pay === 1) || (formData.protection_type === 2 && formData.protection_status === 0)) && ruleForm.protection_status===-1" label="原因" prop="error_msg">
                <el-input v-model="ruleForm.error_msg" type="textarea" placeholder="请输入原因" />
              </el-form-item>
              <el-form-item v-if="(formData.protection_type === 1 && formData.protection_status === 1 && formData.is_pay === 1) || (formData.protection_type === 2 && formData.protection_status === 0)">
                <el-button type="primary" @click="onSubmit">提交</el-button>
              </el-form-item>
            </el-row>
          </el-form>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { roterPre } from '@/settings'
import {
  appraisalBrandDeleteApi,
  appraisalBrandListApi, appraisalBrandSelectListApi, appraisalCateSelectListApi,
  appraisalEntityCardListApi,
  appraisalEntityChartListApi,
  appraisalEntityListApi, appraisalOrderEntityAuditApi, appraisalOrderEntityDetailApi,
  appraisalOrderEntityUpdateApi,
} from "@/api/appraisal";
import {fromList} from "@/libs/constants";
import {communityAuditApi, communityDetailApi, communityUpdateApi} from "@/api/community";
import {
  protectionAuditApi,
  protectionChartListApi,
  protectionDeleteApi,
  protectionDetailApi,
  protectionListApi
} from "@/api/protection";
export default {
  name: 'appraisalEntityOrder',
  components: {},
  data() {
    return {
      moren: require("@/assets/images/f.png"),
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      roterPre: roterPre,
      tableFrom: {
        page: 1,
        limit: 20,
      },
      orderChartType: {},
      fromList: fromList,
      cardLists: [],
      timeVal: [],
      dialogVisible:false,
      loading: false,
      formData: {},
      ruleForm:{
        'protection_status':2,
        'pay_price': '',
        'error_msg': ''
      },
      protection_id:'',
      brandSelect: [],
      cateSelect:[]
    }
  },
  mounted() {
    this.getList(1)
    this.headerList()
  },
  methods: {
    onSubmit() {
      protectionAuditApi(this.protection_id,this.ruleForm).then(res => {
        this.$message.success(res.message)
        this.dialogVisible = false
        this.getList('')
      }).catch(res => {
        this.$message.error(res.message)
      })
    },
    // 详情
    onDetail(id) {
      this.protection_id = id;
      this.dialogVisible = true;
      this.isExamine = false;
      protectionDetailApi(id).then((res) => {
        this.formData = res.data
      }).catch(({ message }) => {
        this.$message.error(message)
      })
    },
    // 编辑
    onEdit(id) {
      this.$modalForm(appraisalOrderEntityUpdateApi(id)).then(() => this.getList(''))
    },
    headerList() {
      protectionChartListApi()
        .then((res) => {
          this.orderChartType = res.data;
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    // 选择时间
    selectChange(tab) {
      this.tableFrom.date = tab;
      this.tableFrom.page = 1;
      this.timeVal = [];
      this.getList(1);
    },
    // 具体日期
    onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.date = e ? this.timeVal.join("-") : "";
      this.tableFrom.page = 1;
      this.getList(1);
    },
    // 列表
    getList(num) {
      this.listLoading = true
      this.tableFrom.page = num ? num : this.tableFrom.page
      protectionListApi(this.tableFrom).then(res => {
        this.tableData.data = res.data.list
        this.tableData.total = res.data.count
        this.listLoading = false
      }).catch(res => {
        this.listLoading = false
        this.$message.error(res.message)
      })
    },
    pageChange(page) {
      this.tableFrom.page = page
      this.getList('')
    },
    handleSizeChange(val) {
      this.tableFrom.limit = val
      this.getList('')
    },
    // 删除
    handleDelete(id, idx) {
      this.$modalSure('确定删除该订单吗？').then(() => {
        protectionDeleteApi(id).then(({ message }) => {
          this.$message.success(message)
          this.getList('')
        }).catch(({ message }) => {
          this.$message.error(message)
        })
      })
    },
  }
}
</script>

<style scoped lang="scss">
.box-container {
  overflow: hidden;
}
.box-container .list {
  float: left;
  line-height: 40px;
}
.box-container .sp {
  width: 50%;
}
.box-container .sp3 {
  width: 33.3333%;
}
.box-container .sp100 {
  width: 100%;
}
.box-container .list .name {
  display: inline-block;
  width: 150px;
  text-align: right;
  color: #606266;
}
.box-container .list.image {
  margin-bottom: 40px;
}
.box-container .list.image img {
  position: relative;
  top: 40px;
}
/deep/.el-form-item__content .el-rate{
  position: relative;
  top: 8px;
}
</style>
